export default function SystemSentimentIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_87669_28643'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_87669_28643)'>
        <path
          d='M7.50112 21.4222V16.4992H2.57812V7.49917H7.50112V2.57617H16.5011V7.49917H21.4241V16.4992H16.5011V21.4222H7.50112ZM4.07812 11.2492H9.00112C9.12929 11.2492 9.24754 11.2796 9.35587 11.3404C9.46421 11.4014 9.55046 11.4826 9.61463 11.5839L10.7781 13.3164L12.2916 8.77617C12.3455 8.62101 12.4358 8.49442 12.5626 8.39642C12.6896 8.29826 12.8351 8.24917 12.9991 8.24917C13.1255 8.24917 13.2455 8.28017 13.3591 8.34217C13.4726 8.40417 13.561 8.48476 13.6241 8.58392L15.3914 11.2492H19.9241V8.99917H15.0011V4.07617H9.00112V8.99917H4.07812V11.2492ZM9.00112 19.9222H15.0011V14.9992H19.9241V12.7492H15.0011C14.876 12.7492 14.757 12.7173 14.6444 12.6534C14.5317 12.5898 14.4378 12.5069 14.3626 12.4049L13.2241 10.6819L11.7106 15.2222C11.6568 15.3773 11.5623 15.5039 11.4271 15.6019C11.2918 15.7001 11.1412 15.7492 10.9754 15.7492C10.8477 15.7492 10.7297 15.7188 10.6214 15.6579C10.513 15.5969 10.4268 15.5158 10.3626 15.4144L8.58588 12.7492H4.07812V14.9992H9.00112V19.9222Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
